import { apiBase, fetchUsingApi } from "../core/apiClient";
import { Room } from "../models/room";

export const createRoom = async (householdId: number, name: string, floor: number = 1): Promise<Room> => {
  const response = await fetchUsingApi<Room>(
    `${apiBase}/room/v1/create`,
    "POST",
    (json: any) => json as Room,
    JSON.stringify({
      householdId,
      name,
      floor,
    }),
  );

  if (response.success) {
    return response.result;
  }
  throw response.message;
};

export const deleteRoom = async (householdId: number, roomId: number): Promise<void> => {
  const response = await fetchUsingApi<void>(
    `${apiBase}/room/v1/remove`,
    "DELETE",
    () => undefined,
    JSON.stringify({
      householdId,
      roomId,
    }),
  );

  if (response.success) {
    return;
  }
  throw response.message;
};

export const renameRoom = async (householdId: number, roomId: number, newName: string): Promise<Room> => {
  const response = await fetchUsingApi<Room>(
    `${apiBase}/room/v1/rename`,
    "PUT",
    (json: any) => json as Room,
    JSON.stringify({
      householdId,
      roomId,
      newName,
    }),
  );

  if (response.success) {
    return response.result;
  }
  throw response.message;
};

export const updateRoom = async (householdId: number, roomId: number, name?: string, floor?: number): Promise<Room> => {
  const response = await fetchUsingApi<Room>(
    `${apiBase}/room/v1/update`,
    "PUT",
    (json: any) => json as Room,
    JSON.stringify({
      householdId,
      roomId,
      name,
      floor,
    }),
  );

  if (response.success) {
    return response.result;
  }
  throw response.message;
};
